import { inr, num, periodLabel } from "./iaUtils";

export const periodColumns = (group) => [
  { key: "period", label: "Period", render: (r) => (r.period === "TOTAL" ? "TOTAL" : periodLabel(r.period, group)), text: (r) => r.period },
  { key: "sr_created", label: "SRs created", align: "right", render: (r) => num(r.sr_created) },
  { key: "sr_completed", label: "SRs completed", align: "right", render: (r) => num(r.sr_completed) },
  { key: "inv_generated", label: "Inv. generated #", align: "right", render: (r) => num(r.inv_generated) },
  { key: "inv_generated_amt", label: "Inv. generated ₹", align: "right", render: (r) => inr(r.inv_generated_amt) },
  { key: "inv_paid", label: "Inv. paid #", align: "right", render: (r) => num(r.inv_paid) },
  { key: "inv_paid_amt", label: "Inv. paid ₹", align: "right", render: (r) => inr(r.inv_paid_amt) },
  { key: "collected", label: "Collected ₹", align: "right", render: (r) => inr(r.collected) },
  { key: "outstanding", label: "Outstanding ₹", align: "right", render: (r) => inr(r.outstanding) },
  { key: "health_created", label: "Health bookings", align: "right", render: (r) => num(r.health_created) },
  { key: "health_collected", label: "Health ₹", align: "right", render: (r) => inr(r.health_collected) },
];

export const customerColumns = [
  { key: "name", label: "Customer" },
  { key: "code", label: "Code" },
  { key: "phone", label: "Phone" },
  { key: "sr_created", label: "SRs created", align: "right" },
  { key: "sr_completed", label: "SRs completed", align: "right" },
  { key: "inv_generated", label: "Inv. generated", align: "right" },
  { key: "inv_paid", label: "Inv. paid", align: "right" },
  { key: "inv_unpaid", label: "Unpaid inv.", align: "right" },
  { key: "billed", label: "Billed ₹", align: "right", render: (r) => inr(r.billed) },
  { key: "paid", label: "Paid ₹", align: "right", render: (r) => inr(r.paid) },
  { key: "due", label: "Due ₹", align: "right", render: (r) => <span className={r.due > 0 ? "text-[#B42828] font-semibold" : ""}>{inr(r.due)}</span>, text: (r) => inr(r.due) },
  { key: "last_payment", label: "Last payment" },
  { key: "oldest_unpaid_days", label: "Oldest unpaid (d)", align: "right", sortValue: (r) => r.oldest_unpaid_days ?? -1 },
];

// Plain-text cell value used by CSV / PDF exports.
export const cellText = (c, r) => {
  if (c.text) return c.text(r);
  if (c.render) { const v = c.render(r); return typeof v === "string" ? v : r[c.key]; }
  return r[c.key] ?? "";
};
